(function() { window.GUID_0ca69993_be05_42e0_b048_6bb1b96a784c = { getGuid: function() { return "0ca69993-be05-42e0-b048-6bb1b96a784c"; } }; })();
var CS;
(function (CS) {
    let Types;
    (function (Types) {
        class Reference {
            constructor(dummyValue) {
                this.dummyValue = dummyValue;
            }
        }
        Types.Reference = Reference;
        function IsJquery(instanceObject) {
            return Is(instanceObject, jQuery);
        }
        Types.IsJquery = IsJquery;
        function IsPrimitiveControl(instanceObject) {
            return Is(instanceObject, CS.Controls.PrimitiveControlBase);
        }
        Types.IsPrimitiveControl = IsPrimitiveControl;
        function IsCSInstanceBase(instanceObject) {
            return Is(instanceObject, CS.CSInstanceBase);
        }
        Types.IsCSInstanceBase = IsCSInstanceBase;
        function IsViewBase(instanceObject) {
            return Is(instanceObject, CS.Views.ViewBase);
        }
        Types.IsViewBase = IsViewBase;
        function IsArray(instanceObject) {
            if (instanceObject == null)
                return false;
            return Array.isArray(instanceObject);
        }
        Types.IsArray = IsArray;
        function IsArrayOf(instanceObject, type) {
            if (IsArray(instanceObject)) {
                if (instanceObject.length > 0) {
                    for (var i = 0; i < instanceObject.length; i++) {
                        if (!Is(instanceObject[i], type))
                            return false;
                    }
                    return true;
                }
            }
            return false;
        }
        Types.IsArrayOf = IsArrayOf;
        function IsEnum(instance) {
            let keys = Object.keys(instance);
            let values = [];
            for (let key of keys) {
                let value = instance[key];
                if (typeof value === 'number') {
                    value = value.toString();
                }
                values.push(value);
            }
            for (let key of keys) {
                if (values.indexOf(key) < 0) {
                    return false;
                }
            }
            return true;
        }
        Types.IsEnum = IsEnum;
        function Is(instanceObject, type) {
            return instanceObject instanceof type;
        }
        Types.Is = Is;
        function IsAbstractOf(instanceObject, type) {
            return Is(instanceObject, type);
        }
        Types.IsAbstractOf = IsAbstractOf;
        function IsConstructorOf(instanceObject, type) {
            return Is(instanceObject, type);
        }
        Types.IsConstructorOf = IsConstructorOf;
        function IsInstanceObject(instanceObject) {
            let fName = instanceObject.toString();
            return (fName.substring(0, 8) != "function" && instanceObject["constructor"]);
        }
        Types.IsInstanceObject = IsInstanceObject;
        function GetContextName(context, uniqueByInstance = false) {
            if (typeof context === 'string' || context instanceof String) {
                return context;
            }
            else if (uniqueByInstance) {
                if (context["UniqueNamespace"])
                    return context["UniqueNamespace"];
                if (context["UniqueInstanceId"])
                    return context["UniqueInstanceId"];
            }
            return GetName(context);
        }
        Types.GetContextName = GetContextName;
        function GetName(type) {
            let fName = type.toString();
            if (fName.substring(0, 8) != "function")
                fName = type["constructor"].toString(); //instanceObject
            let matches = fName.match(/^function\s*([^\s(]+)/);
            if (matches) {
                return matches[1];
            }
            return "";
        }
        Types.GetName = GetName;
    })(Types = CS.Types || (CS.Types = {}));
    // export module Types {
    // }
    function Is(i, type) {
        CS.Size;
        return Types.Is(i, type);
    }
    CS.Is = Is;
})(CS || (CS = {}));

//# sourceMappingURL=cs-types.js.map
